var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.localedTo,"tag":_vm.tag,"exact":_vm.exact,"append":_vm.append,"replace":_vm.replace,"activeClass":_vm.activeClass,"exactActiveClass":_vm.exactActiveClass,"event":_vm.event}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }